/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Mikhail Kokoulin
 * @author Anton Panasenko
 * @version 1.1.0
 * @since 1.0.0
 */
import produce from 'immer';
import { Reducer } from 'redux';

import {
    GET_TEMPORARY_PASSWORD,
    GET_TEMPORARY_PASSWORD_FAILURE,
    GET_TEMPORARY_PASSWORD_SUCCESS,
    initialChangePasswordState,
    SUBMIT_CHANGE_PASSWORD_FORM_FAILURE,
    SUBMIT_CHANGE_PASSWORD_FORM_START,
    SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS,
} from '../constants/changePasswordConstants';
import { IChangePasswordState, SubmitChangePasswordType } from '../types/changePasswordTypes';

const changePasswordReducer: Reducer<IChangePasswordState, SubmitChangePasswordType> =
    (state = initialChangePasswordState, action: SubmitChangePasswordType) =>
    produce(state, draft => {
        switch (action.type) {
            case SUBMIT_CHANGE_PASSWORD_FORM_START:
                break;
            case SUBMIT_CHANGE_PASSWORD_FORM_SUCCESS:
                break;
            case SUBMIT_CHANGE_PASSWORD_FORM_FAILURE:
                break;
            case GET_TEMPORARY_PASSWORD:
                break;
            case GET_TEMPORARY_PASSWORD_FAILURE:
                draft.error = action.payload;
                break;
            case GET_TEMPORARY_PASSWORD_SUCCESS:
                draft.alphabet = action.payload.alphabet;
                draft.maxLength = action.payload.maxLength;
                draft.minLength = action.payload.minLength;
                draft.requiredDigit = action.payload.requiredDigit;
                draft.requiredLetter = action.payload.requiredLetter;
                break;
            default:
                break;
        }
    });

export default changePasswordReducer;
